import { motion } from 'framer-motion';
import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Container = styled(motion.hgroup)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  margin: 48rem 0 0;
  gap: 80rem;

  &:before {
    content: '';
    position: absolute;
    top: -48rem;
    left: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background: ${colors.taupe};
  }

  h1,
  h6,
  h4 {
    color: ${colors.taupe};
    ${({ theme: { locale } }) => setTypography('chapterTitleLabel', locale)};
    white-space: pre-wrap;
    user-select: none;
    flex: 1;
    outline: none;
  }

  p {
    color: ${colors.taupe};
    ${({ theme: { locale } }) => setTypography('body2', locale)};
    white-space: pre-wrap;
    user-select: none;
    width: 100%;

    b {
      font-weight: 900;
      font-style: italic;
    }
  }

  ${mediaTablet`
    flex-direction: row;
    gap: 40rem;

    p {
      width: 82%;
    }
  `}
`;

export const Title = styled.div``;
